import React from "react";
import {Tab, Tabs} from "react-bootstrap";

export default ({signtaskId, externalReference, documents}) => (
  <Tabs id="documents">
      {Object.entries(documents).map(([idx, document]) => (
      <Tab key={idx} eventKey={idx} title={document.title}>
        <object data={`/api/signtask/${signtaskId}/document/${document.reference}`} type="application/pdf"
                width="100%" height="800" />
      </Tab>
    ))}
      {Object.entries(documents).filter(x => x[1].isElectronicSignatureAllowed).map(([idx, document]) => (
        <Tab key={idx + '_signed'} eventKey={idx + '_signed'} title={document.title + '*'}>
            <object data={`/api/signtask/${externalReference}/signedDocument/${document.code}`} type="application/pdf"
                    width="100%" height="800" />
        </Tab>
    ))}
  </Tabs>
);